<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot-scope="{ type, disabled }" slot="memberNamesForm">
        <div class="typesetting-member-field">
          <div class="typesetting-member-field__row">
            <div class="typesetting-member-field__box">
              <div class="typesetting-member-field__tags">
                <template v-if="displayMemberTags.length">
                  <el-tag
                    v-for="(tag, idx) in displayMemberTags"
                    :key="tag.key"
                    :closable="type !== 'view'"
                    disable-transitions
                    @close="removeFormMember(idx)"
                  >
                    {{ tag.label }}
                  </el-tag>
                </template>
                <span v-else class="typesetting-member-field__empty">尚未选择组员</span>
              </div>
            </div>
            <el-button
              type="primary"
              size="small"
              class="typesetting-member-field__btn"
              :disabled="disabled || type === 'view'"
              @click="addMember"
            >
              添加组员
            </el-button>
          </div>
        </div>
      </template>
    </avue-crud>

    <!-- 组员选择弹窗 -->
    <member-select-dialog
      ref="memberSelectDialog"
      :visible.sync="memberSelectDialogVisible"
      :current-row="form"
      @confirm="handleMemberConfirm"
    />
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {getList, add, update, remove, getDetail} from "./api";
import MemberSelectDialog from './components/MemberSelectDialog.vue'

export default {
  components: {
    MemberSelectDialog
  },
  mixins: [crudMixins],
  computed: {
    /**
     * 组员展示标签（优先 memberList，否则解析 memberNames）
     */
    displayMemberTags() {
      const list = this.form.memberList
      if (list && list.length) {
        return list.map((m, i) => ({
          key: (m.teamMemberId || m.id || '') + '-' + i,
          label: m.teamMemberName || m.realName || '—',
        }))
      }
      const names = (this.form.memberNames || '').trim()
      if (!names) {
        return []
      }
      return names.split(',').map((n, i) => ({
        key: 'name-' + i + '-' + n,
        label: n.trim(),
      }))
    },
  },
  data() {
    return {
      apiConfig: {getList, add, update, remove, getDetail},
      infoCardData: [], // 卡片数据
      memberSelectDialogVisible: false,
      option: {
        ...this.$store.state.publicOption,
        /** 新增/编辑弹窗单列布局（一行 24 栅格） */
        span: 24,
        column: [
          // {
          // label: '班次编码',
          // prop: 'teamNo',
          // search: false, // 查询是否显示
          // minWidth: 150, // 表格最小宽度
          // type: 'input',
          // remote: true,
          // dicUrl: '/api/produce/produce-team/select/distinct/pycode?name={{key}}',
          // props: {
          // label: 'teamNo',
          // value: 'teamNo'
          // },
          // },
          {
            label: '班次名称',
            prop: 'teamNo',
            search: true, // 查询是否显示
            minWidth: 150, // 表格最小宽度
            span: 24,
            type: 'select',
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=base_team_type',
            props: {
              label: 'dictValue',
              value: 'dictKey'
            },
            change: ({value}) => {
              if (value) {
                const arr = this.$refs.crud.DIC.teamNo.filter(ii => ii.dictKey === value)
                this.form.teamName = arr[0].dictValue
              }
            },
          },
          // {
          //   label: '组长ID',
          //   prop: 'teamLeaderId',
          // },
          // {
          // label: '组长姓名',
          // prop: 'teamLeaderName',
          // search: true, // 查询是否显示
          // minWidth: 150, // 表格最小宽度
          // type: 'select',
          // remote: true,
          // dicUrl: '/api/produce/produce-team/select/distinct/pycode?name={{key}}',
          // props: {
          //   label: 'teamLeaderName',
          //   value: 'teamLeaderName'
          // },
          // },
          {
            label: '组员',
            search: false, // 查询是否显示
            minWidth: 220,
            span: 24,
            prop: 'memberNames',
            formslot: true,
            slotName: 'memberNamesForm',
          },
          {
            label: '备注',
            search: false, // 查询是否显示
            prop: 'remark',
            span: 24,
            type: 'textarea',
            minRows: 3,
            maxRows: 6,
            maxlength: 200,
            showWordLimit: true,
          },

          // {
          // label: '是否有效',
          //   search: false, // 查询是否显示
          // prop: 'status',
          // },
          // {
          //   ...searchTimeConfig,
          //   paramsKey: ["startTime", "endTime"],
          // },
        ]
      },
    }
  },
  methods: {
    /**
     * 打开弹窗前拉取详情时，补齐 memberList，便于标签展示与组员弹窗回显
     */
    beforeOpen(done, type) {
      this.openType = type
      if (['edit', 'view'].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig
          .getDetail(this.form.id)
          .then((res) => {
            this.form = res.data.data || res.data
            this.normalizeFormMembers(this.form)
            done()
          })
          .catch(() => done())
      } else {
        done()
      }
    },

    /**
     * 将后端返回的 memberNames/memberIds 转为 memberList
     */
    /**
     * 是否已选择至少一名组员（与列表展示口径一致）
     */
    hasSelectedMembers(row) {
      const r = row || this.form
      if (!r) {
        return false
      }
      if (r.memberList && r.memberList.length > 0) {
        return true
      }
      const names = (r.memberNames || '').trim()
      return names.length > 0
    },

    /**
     * 新增：提交前校验组员
     */
    rowSave(row, done, loading) {
      if (!this.hasSelectedMembers(row)) {
        this.$message.warning('请选择组员')
        loading()
        return
      }
      this.apiConfig.add(row).then(
        () => {
          this.selectionClear()
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功',
          })
          done()
        },
        () => {
          loading()
        }
      )
    },

    /**
     * 编辑：提交前校验组员
     */
    rowUpdate(row, index, done, loading) {
      if (!this.hasSelectedMembers(row)) {
        this.$message.warning('请选择组员')
        loading()
        return
      }
      this.apiConfig.update(row).then(
        () => {
          this.selectionClear()
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功',
          })
          done()
        },
        () => {
          loading()
        }
      )
    },

    normalizeFormMembers(form) {
      if (!form) {
        return
      }
      if (form.memberList && form.memberList.length) {
        return
      }
      const names = (form.memberNames || '').trim()
      if (!names) {
        return
      }
      const ids = (form.memberIds || '').split(',').map((s) => s.trim())
      const nameArr = names.split(',').map((s) => s.trim())
      const built = nameArr.map((name, i) => ({
        id: ids[i],
        teamMemberId: ids[i],
        teamMemberName: name,
        realName: name,
      }))
      this.$set(form, 'memberList', built)
    },

    /**
     * 打开组员选择：必须传入当前表单 model（memberList/memberNames），不可用表单自定义槽的 row（Avue 下 often 非表单数据）
     */
    addMember() {
      this.memberSelectDialogVisible = true
    },

    /**
     * 移除一名组员并同步 memberIds、memberNames（使用 $set 保证 Avue 表单与 Vue2 响应式更新）
     */
    removeFormMember(index) {
      const list = this.form.memberList
      if (list && list.length > 0) {
        const next = list.filter((_, i) => i !== index)
        this.$set(this.form, 'memberList', next)
        this.$set(
          this.form,
          'memberIds',
          next.map((m) => m.teamMemberId || m.id).filter(Boolean).join(',')
        )
        this.$set(
          this.form,
          'memberNames',
          next.map((m) => m.teamMemberName || m.realName).join(',')
        )
        return
      }
      const tags = this.displayMemberTags
      if (!tags.length) {
        return
      }
      const nextNames = tags.map((t) => t.label).filter((_, i) => i !== index)
      this.$set(this.form, 'memberNames', nextNames.join(','))
      this.$set(this.form, 'memberIds', '')
      this.$set(this.form, 'memberList', [])
    },

    /**
     * 处理组员选择确认
     */
    handleMemberConfirm(data) {
      const sourceList = data.memberList && data.memberList.length
        ? data.memberList
        : []
      const existingList = this.form.memberList && this.form.memberList.length
        ? this.form.memberList
        : []
      const merged = []
      ;[...existingList, ...sourceList].forEach((member) => {
        const memberId = member.teamMemberId || member.id
        const memberName = member.teamMemberName || member.realName
        if (!memberId && !memberName) {
          return
        }
        const existed = merged.some((item) => {
          const itemId = item.teamMemberId || item.id
          const itemName = item.teamMemberName || item.realName
          return memberId ? String(itemId) === String(memberId) : itemName === memberName
        })
        if (!existed) {
          merged.push(member)
        }
      })
      const mapped = merged.map((ii) => ({
        ...ii,
        teamMemberId: ii.teamMemberId || ii.id,
        teamMemberName: ii.teamMemberName || ii.realName,
      }))
      this.$set(
        this.form,
        'memberIds',
        mapped.map((m) => m.teamMemberId).filter(Boolean).join(',')
      )
      this.$set(
        this.form,
        'memberNames',
        mapped.map((m) => m.teamMemberName || m.realName).filter(Boolean).join(',')
      )
      this.$set(this.form, 'memberList', mapped)
    },

  },
}
</script>
<style scoped lang="scss">
.typesetting-member-field {
  width: 100%;
}
.typesetting-member-field__row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}
.typesetting-member-field__box {
  flex: 1;
  min-width: 0;
  min-height: 36px;
  padding: 8px 10px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #f7f8fa;
}
.typesetting-member-field__btn {
  flex-shrink: 0;
  margin-top: 2px;
}
.typesetting-member-field__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}
.typesetting-member-field__empty {
  font-size: 13px;
  color: #909399;
  line-height: 22px;
}
.typesetting-member-field__hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
</style>
